import { render, staticRenderFns } from "./ContactRequestSentView.vue?vue&type=template&id=71418b02&"
import script from "./ContactRequestSentView.vue?vue&type=script&lang=js&"
export * from "./ContactRequestSentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports